import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Clienti from "@/pages/Clienti";
import ClienteDettaglio from "@/pages/ClienteDettaglio";
import Bici from "@/pages/Bici";
import { Ricambi, Prodotti } from "@/pages/Articoli";
import Schede from "@/pages/Schede";
import SchedaForm from "@/pages/SchedaForm";
import SchedaStampa from "@/pages/SchedaStampa";
import ContrattoNoleggio from "@/pages/ContrattoNoleggio";
import PrivacyStampa from "@/pages/PrivacyStampa";
import DocumentoPubblico from "@/pages/DocumentoPubblico";
import Preventivi from "@/pages/Preventivi";
import Registrati from "@/pages/Registrati";
import Abbonamento from "@/pages/Abbonamento";
import SuperAdmin from "@/pages/SuperAdmin";
import PreventivoForm from "@/pages/PreventivoForm";
import PreventivoStampa from "@/pages/PreventivoStampa";
import AgendaStampa from "@/pages/AgendaStampa";
import CalendarioFlotta from "@/pages/CalendarioFlotta";
import Impostazioni from "@/pages/Impostazioni";
import Cassa from "@/pages/Cassa";
import Tagliandi from "@/pages/Tagliandi";
import Agenda from "@/pages/Agenda";
import Noleggi from "@/pages/Noleggi";
import Flotta from "@/pages/Flotta";
import Presentazione from "@/pages/Presentazione";

const Protected = ({ children }) => {
  const { user } = useAuth();
  if (user === null) return <div className="flex min-h-screen items-center justify-center text-sm text-slate-500">Caricamento...</div>;
  if (!user) return <Navigate to="/login" replace />;
  return children;
};

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/registrati" element={<Registrati />} />
          <Route path="/scopri" element={<Presentazione />} />
          <Route path="/documento/:token" element={<DocumentoPubblico />} />
          <Route path="/schede/:id/stampa" element={<Protected><SchedaStampa /></Protected>} />
          <Route path="/preventivi/:id/stampa" element={<Protected><PreventivoStampa /></Protected>} />
          <Route path="/agenda/stampa" element={<Protected><AgendaStampa /></Protected>} />
          <Route path="/noleggi/:id/contratto" element={<Protected><ContrattoNoleggio /></Protected>} />
          <Route path="/clienti/:id/privacy" element={<Protected><PrivacyStampa /></Protected>} />
          <Route element={<Protected><Layout /></Protected>}>
            <Route index element={<Dashboard />} />
            <Route path="schede" element={<Schede />} />
            <Route path="schede/nuova" element={<SchedaForm />} />
            <Route path="schede/:id" element={<SchedaForm />} />
            <Route path="preventivi" element={<Preventivi />} />
            <Route path="preventivi/nuovo" element={<PreventivoForm />} />
            <Route path="preventivi/:id" element={<PreventivoForm />} />
            <Route path="clienti" element={<Clienti />} />
            <Route path="clienti/:id" element={<ClienteDettaglio />} />
            <Route path="bici" element={<Bici />} />
            <Route path="ricambi" element={<Ricambi />} />
            <Route path="prodotti" element={<Prodotti />} />
            <Route path="cassa" element={<Cassa />} />
            <Route path="tagliandi" element={<Tagliandi />} />
            <Route path="agenda" element={<Agenda />} />
            <Route path="noleggi" element={<Noleggi />} />
            <Route path="flotta" element={<Flotta />} />
            <Route path="flotta/calendario" element={<CalendarioFlotta />} />
            <Route path="impostazioni" element={<Impostazioni />} />
            <Route path="abbonamento" element={<Abbonamento />} />
            <Route path="superadmin" element={<SuperAdmin />} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </AuthProvider>
  );
}

export default App;
